<template>
  <div
    v-if="$translated(infoTooltipText)"
    v-tooltip
    class="atom-info atom-info--questionMark d-flex align-self-left"
    :title="$t(infoTooltipText)"
  >
    <img src="@/assets/icons/ico-ico-question.svg" />
  </div>
</template>

<script>
export default {
  props: {
    infoTooltipText: {
      type: String,
      required: true
    }
  }
};
</script>
